import React from 'react';
import moment from 'moment';
import { Col, Row, Icon } from 'antd';
import { useFetchOverviewQuery } from '../service';
import { getMostRecentData, getTrendProperties, getChartData } from '../utils';
import { BacklinksOverviewResult, BacklinksOverviewSettings } from '../types';
import LoadingIndicator from '../../components/shared/LoadingIndicator/LoadingIndicator';
import TableColumnWithTooltip from '../../components/shared/TableColumnWithTooltip/TableColumnWithTooltip';
import BacklinksOverviewBox from './BacklinksOverviewBox';
import { BACKLINKS_OVERVIEWS_CHART_INTERVAL_LENGTH_IN_WEEKS } from '../../settings/config';

const endDate = moment().utc();
const endDateStr = endDate.format('YYYY-MM-DDTHH:mm:ss');
const startDate = endDate.subtract(BACKLINKS_OVERVIEWS_CHART_INTERVAL_LENGTH_IN_WEEKS, 'weeks');
const startDateStr = startDate.format('YYYY-MM-DDTHH:mm:ss');

function getTrendIcon(overview: BacklinksOverviewResult, resourceType: keyof BacklinksOverviewResult) {
	const iconProperties = getTrendProperties(overview, resourceType);
	return <Icon type={iconProperties.type} style={iconProperties.style} />;
}

type Props = {
	domain: string;
	settings: BacklinksOverviewSettings;
	showChart: boolean;
};

export default function BacklinksOverview({ domain, settings, showChart }: Props) {
	const { displayOrder, sections } = settings;
	const { data: overviewData, isLoading: isLoadingOverview } = useFetchOverviewQuery({ domain, startDate: startDateStr, endDate: endDateStr });

	return (
		<div className="backlinks-overview">
			{isLoadingOverview ? (
				<LoadingIndicator />
			) : overviewData && overviewData['total_backlinks'] && overviewData['total_backlinks'].length ? (
				<Row gutter={20} className="backlinks-overview-wrapper">
					{displayOrder.map((section) => (
						<Col className="overview-box" key={sections[section].key}>
							<BacklinksOverviewBox
								title={<TableColumnWithTooltip title={sections[section].title} tooltip={sections[section].tooltip} noFill />}
								value={getMostRecentData(overviewData, sections[section].key as keyof BacklinksOverviewResult)
									.toString()
									.concat(sections[section].key === 'domain_score' ? '/100' : '')}
								trend={getTrendIcon(overviewData, sections[section].key as keyof BacklinksOverviewResult)}
								chartData={getChartData(overviewData, sections[section].key as keyof BacklinksOverviewResult)}
								showChart={showChart}
							/>
						</Col>
					))}
				</Row>
			) : null}
		</div>
	);
}
